import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const DefaultRoleToast = ({ name }) => (
  <PositiveToast className="aridhia-default-role-toast">
    <FormattedMessage id="toast.default.role.updated" values={{ name }} />
  </PositiveToast>
);

export default DefaultRoleToast;
